import React from "react";
import "./Card.css";
import StarsIcon from '@material-ui/icons/Stars';

function index({ src, title, text,rating }) {
  return (
    <div className="card">
        <a href="">

      <img src={src} alt="cardimage" />
      <h1>{title}</h1>
      <div className="rating">
      <StarsIcon />
        <p>{rating}</p>
      </div>
      <p>from ${text}/night</p>
        </a>
    </div>
  );
}

export default index;
